<template>
	<div v-loading.fullscreen.lock="loading" class="msg_box">
		<div></div>
		<!-- 选择发票信息 -->
		<el-dialog title="发票信息" :show-close="false" :visible.sync="isInvoice" width="1080px" >
			<div v-loading="loading2" class="dizhi_box min_he200">
				<div v-for="(item,i) in invList" :key="item.id" @click="setInvoice(i)" :class="{'dizhi_zi_chon':invoiceIndex==i}" class="dizhi_zi  clearfloat">
					<span class="flo_lf">
						<template v-if="item.type == 1">专票</template>
						<template v-else-if="item.type==2">普票</template>
						{{item.look}}
						{{item.identify_number}}
						<!-- {{}} -->
					</span>
					<div class="dizhi_right">
						<span  v-if="item.is_default != 1"
						@click.stop="Postaddresssetdefault(item.id)">设为默认发票信息</span>
						<span @click="xin.goUrl('/personalCenter/invoice')">编辑</span>
					</div>
				</div>
			</div>
			<div class="clearfloat tgb">
				<div class="flo_right asd" @click="issetinvoice=true">
					新增发票信息
				</div>
			</div>
		</el-dialog>
		<!-- 选择收货地址 -->
		<el-dialog title="收货地址信息" :show-close="false" :visible.sync="dialogVisible" width="1080px" >
			<div  v-loading="loading2"  class="dizhi_box min_he200">
				<div v-for="(item,i) in siteList" :key="item.id" @click="setTake(i)" :class="{'dizhi_zi_chon':takeIndex==i}" class="dizhi_zi  clearfloat">
					<span class="flo_lf">
						{{item.province_name}}
						{{item.city_name}}
						{{item.area_name}}
						{{item.address}}
						{{item.phone}}
					</span>
					<div class="dizhi_right">
						<span  v-if="item.is_default != 1"
						@click.stop="setdihzimor(item.id)">设为默认地址</span>
						<span @click="xin.goUrl('/personalCenter/site')">编辑</span>
					</div>
				</div>
			</div>
			<div class="clearfloat tgb">
				<div class="flo_right asd" @click="addsite=true">
					新增收货地址
				</div>
			</div>
		</el-dialog>
		<!-- 选择发票地址 -->
		<el-dialog title="发票地址信息" :show-close="false" :visible.sync="dialogVisible2" width="1080px" >
			<div  v-loading="loading2"  class="dizhi_box min_he200">
				<div v-for="(item,i) in siteList" :key="item.id" @click="setTake2(i)" :class="{'dizhi_zi_chon':billIndex==i}" class="dizhi_zi  clearfloat">
					<span class="flo_lf">
						{{item.province_name}}
						{{item.city_name}}
						{{item.area_name}}
						{{item.address}}
						{{item.phone}}
					</span>
					<div class="dizhi_right">
						<span  v-if="item.is_default != 1"
						@click.stop="setdihzimor(item.id)">设为默认地址</span>
						<span @click="xin.goUrl('/personalCenter/site')">编辑</span>
					</div>
				</div>
			</div>
			<div class="clearfloat tgb">
				<div class="flo_right xiahua asd" @click="addsite=true">
					+新增收货地址
				</div>
			</div>
		</el-dialog>
		<!-- 进度条 -->
		<div class="schedule_box">
			<div class="schedule_one">
				<span>1</span>我的购物车
			</div>
			<div class="schedule_two">
				<span>2</span>确认订单信息
			</div>
			<div class="schedule_three">
				<span>3</span>成功提交订单
			</div>
		</div>
		<div class="tech_title">确认订单信息</div>
		<!-- 产品信息 -->
		<div class="order_to"><span>货号</span>
			<span>商品名称</span>
			<span>规格</span>
			<span>单价</span>
			<span>商品数量</span>
			<span>总价</span>
		</div>
		<div  class="chopping_box">
			<div class="chopping_zi" v-for="(itme) in shoppingList" :key="itme.id">
				<div class="chopping_li">
					{{itme.model}}
				</div>
				<div class="chopping_li chopping_goods clearfloat">
					<img class="flo_lf"  @click="xin.goUrl('/goodsDetails?gid='+itme.goods_id)" :src="itme.images" />
					<div class="flo_lf asdmoi">
						<div >
							<span class="cur_po" @click="xin.goUrl('/goodsDetails?gid='+itme.goods_id)">{{itme.title}}</span>
						</div>
						<!-- @click="xin.goUrl('/oneDetails?cid='+itme.goods_id)" -->
						<div class="lan" @click="xin.goUrl('/oneDetails?cid='+itme.goods_category_id)" v-if="itme.category" >{{itme.category}}</div>
					</div>
				</div>
				<div class="chopping_li">
					{{itme.sku_text}}
				</div>
				<div class="chopping_li">
				¥{{itme.sale_price}}
				</div>
				<div class="chopping_li">
					{{itme.number}}
				</div>
				<div class="chopping_li">
					¥{{itme.total}}
				</div>
			</div>
		</div>
		<div class="invoice_box clearfloat">
			<div class="flo_lf">
				<div>开具发票</div>
				<div class="site_form clearfloat">
					<div class="form_left">专票/普通:</div>
					<div class=" che" >
						<span v-if="invoicemsg.type==1">专票</span>
						<span v-else-if="invoicemsg.type==2">普票</span>
					</div>
				</div>
				<div class="site_form clearfloat">
					<div class="form_left">发票抬头:</div>
					<div class="form_right">{{invoicemsg.look}}</div>
				</div>
				<div class="site_form clearfloat">
					<div class="form_left">纳税人识别号:</div>
					<div class="form_right">{{invoicemsg.identify_number}}</div>
				</div>
				<div class="site_form clearfloat">
					<div class="form_left">专票信息（普票无需填写）:</div>
					<div class="form_right">
						{{invoicemsg.info}}
					</div>
				</div>
				<div class="site_form clearfloat">
					<div class="form_left">备注:</div>
					<div class="form_right "><input placeholder="订购需求或开票需求" v-model="invoicemsg.note" class="beizhu" /></div>
				</div>
			</div>
			<div class="flo_right">
				运送方式：普通配送快递 免邮
			</div>
		</div>
		<div class="mkoa magtop20" ><span  class=" lan xiahua xiahuanxa" @click="isInvoice = true">+使用新发票信息</span></div>
		<div class="tech_title">联系人信息</div>
		<!-- 收货地址 -->
		<div class="dizhi ">
			<div class="dizhi_title">确认收货地址</div>
			<div class="site_zi" >
				<template v-if="address.unit||address.realname">
					<div class="site_form clearfloat">
						<div class="form_left">单位:</div>
						<div class="form_right">{{address.unit}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">收货人:</div>
						<div class="form_right">{{address.realname}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">地区:</div>
						<div class="form_right">
						{{address.province_name}} {{address.city_name}} {{address.area_name}}
						</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">详细地址:</div>
						<div class="form_right">{{address.address}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">手机:</div>
						<div class="form_right">{{address.phone}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">或固定电话:</div>
						<div class="form_right">{{address.tel}}</div>
					</div>
				</template>
					<div v-else class="site_form clearfloat">
							<div class="liuko">收票地址为空</div>
					</div>
				<div><span  @click="shodizhi" class="lan xiahua xiahuanxa" >+使用新地址</span></div>
			</div>
		</div>
		<!-- 发票地址 -->
		<div class="dizhi ">
			<div class="dizhi_title">确认收票地址</div>
			<div class="site_zi" >
					<template v-if="address.unit||address.realname">
						<div class="site_form clearfloat">
							<div class="form_left">单位:</div>
							<div class="form_right">{{invoice.unit}}</div>
						</div>
						<div class="site_form clearfloat">
							<div class="form_left">收货人:</div>
							<div class="form_right">{{invoice.realname}}</div>
						</div>
						<div class="site_form clearfloat">
							<div class="form_left">地区:</div>
							<div class="form_right">
								{{invoice.province_name}} {{invoice.city_name}} {{invoice.area_name}}
							</div>
						</div>
						<div class="site_form clearfloat">
							<div class="form_left">详细地址:</div>
							<div class="form_right">{{invoice.address}}</div>
						</div>
						<div class="site_form clearfloat">
							<div class="form_left">手机:</div>
							<div class="form_right">{{invoice.phone}}</div>
						</div>
						<div class="site_form clearfloat">
							<div class="form_left">或固定电话:</div>
							<div class="form_right">{{invoice.tel}}</div>
						</div>
					</template>
					<div v-else class="site_form clearfloat">
							<div class="liuko">收票地址为空</div>
					</div>
				<div ><span class="lan xiahua xiahuanxa" @click="dialogVisible2 = true">+使用新地址</span></div>
			</div>
		</div>
		<div class="clearfloat">
			<div class="flo_right">总金额:
				<span class="jing">￥{{total}}</span>
			</div>
		</div>
		<div class="clearfloat">
			<div class="flo_right moas">
				<button @click="submit" v-notClick="isTosub"  class="flo_right laing_btn">提交</button>
				<div class="flo_right">
					<el-checkbox v-model="checked">已同意</el-checkbox><span class="lan" @click="xin.goUrl('/orderAgreement')">《订购协议》</span>
				</div>
			</div>
		</div>
			<!-- 添加地址 -->
		<el-dialog title="添加地址" :visible.sync="addsite" width="600px" :before-close="closeform" :close-on-click-modal="false" >
		<div>
			<el-form :model="addruleForm" :rules="rules" ref="adddizhi" label-width="130px" class="demo-ruleForm">
				<el-form-item label="单位" prop="unit">
					<el-autocomplete style="width:100%" class="inline-input" v-model="addruleForm.unit" :fetch-suggestions="querySearch"
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="收货人" prop="realname">
					<el-input v-model="addruleForm.realname"></el-input>
				</el-form-item>
				<el-form-item label="地区" prop="addrid">
					<el-cascader style="width:100%" v-model="addruleForm.addrid" placeholder="试试搜索：上海市" :options="region"
						filterable expand-trigger="hover" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="详细地址" prop="address">
					<el-input v-model="addruleForm.address"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="phone">
					<el-input v-model="addruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="或者固定电话" prop="tel">
					<el-input v-model="addruleForm.tel"></el-input>
				</el-form-item>
				<el-form-item label="设为默认地址" prop="is_default">
					<el-switch v-model="addruleForm.is_default"></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="closeform('')">取 消</el-button>
			<el-button type="primary" @click="adddizhi">确 定</el-button>
		</span>
	</el-dialog>
	<!-- 添加发票信息 -->
	<el-dialog title="发票信息" :visible.sync="issetinvoice" width="600px" :before-close="closeform" :close-on-click-modal="false" >
		<div>
			<el-form :model="addruleForm2" :rules="rules2" ref="adddizhi" label-width="130px" class="demo-ruleForm">
				 <el-form-item label="专票/普通" prop="type">
					<el-radio-group v-model="addruleForm2.type">
						<el-radio :label="1">专票</el-radio>
						<el-radio :label="2">普通</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发票抬头" prop="look">
					<!-- <el-input v-model="addruleForm.look"></el-input> -->
					<el-autocomplete style="width:100%"  class="inline-input" v-model="addruleForm2.look" :fetch-suggestions="querySearch2" 
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect2" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="纳税人识别号" prop="identify_number">
					<el-input v-model="addruleForm2.identify_number"></el-input>
				</el-form-item>
				<el-form-item v-if="addruleForm2.type==1" label="专票信息" prop="info">
					<el-input type="textarea" v-model="addruleForm2.info"></el-input>
				</el-form-item>
				<el-form-item label="设为默认发票" prop="is_default">
					<el-switch v-model="addruleForm2.is_default"></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="closeform2('')">取 消</el-button>
			<el-button type="primary" @click="addfap">确 定</el-button>
		</span>
	</el-dialog>
	</div>
</template>

<script>
import city from '@/utlis/city.js'
	import {mapActions} from 'vuex'
	export default{
		data(){
			return{
				loading2:false,
				loading:true,
				isTosub:true,
				istone:true,//是否使用默认地址为选择项
				issetinvoice:false,//添加发票地址
				goods:{},//产品内容
				dialogVisible2:false,
				billIndex:-1,//发票地址索引
				takeIndex:-1,//收货索引
				invoiceIndex:-1,//发票选择索引
				checked:true,//《订购协议》
				invList:[],//发票列表
				isInvoice:false,//发票列显示
				siteList:[],//地址列表
				addsite:false,//添加地址
				dialogVisible:false,//地址列显示
				address:{},//收货地址
				invoice:{},//发票地址
				invoicemsg:{},//发票信息
				total:0,//总价格
				shoppingList: [],//产品信息
				region: [],// 地址三级
				addruleForm2:{
					type:'',//发票类型
					look:'',//发票抬头
					identify_number:'',//纳税人识别号
					info:'',//专票信息
					is_default:0,// 是否是默认发票
					note:'',//备注
				},
				rules2:{
					type:{ required: true, message: '请选择发票类型', trigger: 'change' },
					look:{ required: true, message: '请输入发票抬头', trigger: 'blur' },
					identify_number:{ required: true, message: '请输入纳税人识别号', trigger: 'blur' },
					info:{ required: true, message: '请输入专票信息', trigger: 'blur' },
				},
				addruleForm:{
					realname:'',//姓名
					phone:'',//电话
					address:'',//详细地址
					tel:'',//固定电话
					addrid:'',//地址
					is_default:0,//是否设为默认地址
					unit:'',//单位
				},
				rules:{
					realname:{ required: true, message: '请输入姓名', trigger: 'blur' },
					phone: { required: true, message: '请输入手机号', trigger: 'blur' },
					// tel:{ validator: validatePass, trigger: 'blur' },
					addrid:[{type: 'array', required: true, message: '请选择地区', trigger: 'change' }],
					address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
					unit:{ required: true, message: '请输入单位', trigger: 'blur' },
				},
			}
		},
		created(){
			let params = this.$route.params;
			let stoparams = JSON.parse(sessionStorage.getItem('params')||'{}');
			if(params.goods){
				let goods = {goods:params.goods,is_cart:params.is_cart};
				sessionStorage.setItem('params',JSON.stringify(goods))
				this.PostGoodcoupon(params.goods,params.is_cart);
				this.goods = goods;
			}else if(stoparams.goods){
				this.PostGoodcoupon(stoparams.goods,stoparams.is_cart);
				this.goods = stoparams;
			}else{
				this.xin.backPage()
				return;
			}
			this.Postaddressget();
			this.Postinvoiceget();
			this.region = this.asd(city.data||[])
			// this.Postaddresstree();
			//页面刷新提示
			window.onbeforeunload = function(){ return '您即将离开本页面,确定继续吗?'; } 
		},
		beforeDestroy(){
			window.onbeforeunload =null;
		},
		methods:{
			...mapActions(['setgoodsCount']),
			async querySearch2(queryString, cb) {//发票抬头搜索
				let {data} = await this.api.Postlook({title:queryString});
				cb(data);
			},
			handleSelect2(e){//添加选择发票
				this.addruleForm2.identify_number = e.taxpayer_number;
				this.addruleForm2.look = e.name;
			},
			addfap(){//添加发票
				this.$refs.adddizhi.validate(async (valid) => {
					if (!valid) return;
					let addruleForm2 = Object.assign({},this.addruleForm2);
					if(addruleForm2.type==2)addruleForm2.info='';
					this.istone =  addruleForm2.is_default;
					addruleForm2.is_default = addruleForm2.is_default?1:0;
					let {code} = await this.api.Postinvoiceadd(addruleForm2);
					if(code==200){
						this.$message({ message: '发票信息添加成功', type: 'success' });
						this.closeform2('');
						this.Postinvoiceget();
					}
				});
			},
			async querySearch(queryString, cb) {//单位搜索
				let {data} = await this.api.Postuserunit({title:queryString})
				cb(data);
			},
			handleSelect(e){//添加选择单位
				this.addruleForm.unit = e.name;
			},
			closeform2(done) {//关闭添加地址
				this.$refs.adddizhi.resetFields();
				if(done) done();
				this.issetinvoice = false;
			},
			closeform(done) {//关闭添加地址
				this.$refs.adddizhi.resetFields();
				if(done) done();
				this.addsite = false;
			},
			adddizhi(){//添加地址
				this.$refs.adddizhi.validate(async (valid) => {
				if (!valid) return;
				let dizhi = '';
				let addruleForm = Object.assign({},this.addruleForm);
					addruleForm.addrid.forEach(v=>{
						dizhi+=v+',';
					})
					addruleForm.addrid = dizhi;
					this.istone = addruleForm.is_default;
					addruleForm.is_default = addruleForm.is_default?1:0;
					let {code} = await this.api.Postaddressadd(addruleForm);
					if(code==200){
						this.$message({ message: '地址添加成功', type: 'success' });
						this.closeform('');
						this.Postaddressget();
						// this.invoice = Object.assign({},this.siteList[0]);
						// this.address = Object.assign({},this.siteList[0]);
					}
				});
			},
			async Postaddresstree(){//获取省市区
				let {data} = await this.api.Postaddresstree();
				this.region = this.asd(data);
			},
			asd(list){//遍历
				return list.map((v,i)=>{
					v.label = v.name;
					// delete v.name;
					v.value = v.id;
					if(v.datas){
						v.children = this.asd(v.datas);
						delete v.datas;
					}
					return v;
				})
			},
			async submit(){//提交
				if(!this.invoicemsg.id)
					this.$message({ message: '请选择发票信息', type: 'warning' });
				else if(!this.address.area_name)
					this.$message({ message: '请选择收货地址', type: 'warning' });
				else if(!this.invoice.area_name)
					this.$message({ message: '请选择发票地址', type: 'warning' });
				else if(!this.checked)
					this.$message({ message: '请勾选《订购协议》', type: 'warning' });
				else{
					this.isTosub = false;
					let {code,data} = await this.api.PostordersCreate({
						goods_info:JSON.stringify(this.goods.goods),
						is_cart:this.goods.is_cart,
						address_id:this.address.id,
						invoice:JSON.stringify(this.invoicemsg),
						invoice_address_id:this.invoice.id,
						device:"PC"
					});
					this.isTosub = true;
					if(code==200){
						this.setgoodsCount();
						sessionStorage.removeItem('params');
						this.xin.goUrl('/succeedOrder?order_id='+data.order_id);
					}
				}
			},
			async setdihzimor(address_id){//设为默认地址
				let {code} = await this.api.Postaddresssetdefault({address_id});
				let dizhi = await this.Postaddressget();
				this.dialogVisible = false;
				this.dialogVisible2 = false;
				this.address = dizhi[0];
				this.invoice = dizhi[0];
			},
			setTake2(i){//发票地址选择
				this.dialogVisible2 = false;
				this.billIndex = i;
				this.invoice = Object.assign({},this.siteList[i]);
			},
			setTake(i){//收货地址选择
				this.dialogVisible = false;
				this.takeIndex = i;
				this.address = Object.assign({},this.siteList[i]);
			},
			async Postaddresssetdefault(address_id){//设为默认发票信息
				let {code} = await this.api.Postinvoicegetsetdefault({address_id});
				let invList = await this.Postinvoiceget();
				this.isInvoice = false;
				this.invoicemsg = this.invList[0];
			},
			setInvoice(i){//发票信息选择
				this.isInvoice = false;
				this.invoiceIndex = i;
				this.invoicemsg = Object.assign({},this.invList[i]);
			},
			async Postinvoiceget(){//获取发票列
				this.loading2 = true;
				let {data} = await this.api.Postinvoiceget();
				if(this.istone)
				data.data.forEach((v,i) => {
					if(v.is_default==1)
						this.invoiceIndex = i;
				});
				else this.istone = true;
				this.invList = data.data;
				this.loading2 = false;
				return data.data;
			},
			async Postaddressget(){//获取地址列表
			this.loading2=true;
				let {data} = await this.api.Postaddressget();
				if(this.istone)
					data.data.forEach((v,i) => {
						if(v.is_default==1){
							this.takeIndex = i;
							this.billIndex = i;
						}
					});
				else this.istone = true;
				this.siteList = data.data;
				this.invoiceList = data.data;
				this.loading2=false;
				return data.data;
			},
			shodizhi(){//选择收货地址
				this.dialogVisible = true;
			},
			async PostGoodcoupon(goods_info,is_cart){//确认订单信息
				this.loading = true;
				let {data,code} = await this.api.PostGoodcoupon({goods_info:JSON.stringify(goods_info),is_cart});
				if(code==200){
					this.address = data.address;
					this.invoice = data.address;
					this.invoicemsg = data.invoice||{};
					this.shoppingList = data.goods_info;
					this.total = data.total;
				}
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.xiahuanxa{
	border-bottom: 2px solid currentColor;
}
.xiahua{
	text-decoration: underline;
}
.mkoa{
	font-size: 20px;
}
.tgb{
	margin: 20px 0;
}
.clearfloat{
	.asd{
		margin-top: 40px;
		font-size: 24px;
		font-weight: 600;
		text-decoration: underline;
		color: #333333;
		line-height: 19px;
		cursor: pointer;
	}
}
	.dizhi_box{
		.dizhi_zi{
			border: 1px solid #fff;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			box-sizing: border-box;
			cursor: pointer;
			.dizhi_right{
				float: right;
				span{
					margin-left: 10px;
				}
			}
			&:hover{
				// color: #fff;
				border:1px solid var(--themeColor);
			}
		}
		.dizhi_zi_chon{
			background: #005599;
			color: #fff;
			
		}
	}
	.moas{
		margin-top: 50px;
		line-height: 40px;
		.laing_btn{
			width: 210px;
			height: 40px;
			line-height: 40px;
		}
		.lan{
			margin: 0 20px 0 5px;
		}
	}
	.dizhi{
		
		margin-top: 50px;
		.dizhi_title{
			margin-bottom: 20px;
			font-size: 20px;
			color: #333333;
			line-height: 6px;
		}
		.lan{
			font-size: 20px;
		}
	}
	
	
	
	.relation{
		margin-top: 20px;
		color: #666666;
		font-size: 20px;
		.rela_zi{
			line-height: 42px;
			div{
				display: inline-block;
			}
		}
	}
	.invoice_box{
		// height: 310px;
		background: #EFF1F2;
		padding: 30px;
		.flo_lf{
			width: 60%;
			box-sizing: border-box;
			border-right: 1px solid #D0D0D0;
			padding-right: 20px;
		}
		.flo_right{
			width: 40%;
			min-height: 300px;
			display: flex;
			justify-content: center;
			align-items: center;
			
		}
	}
	.site_form {
		margin: 20px 0;
		.liuko{
			padding: 0 20px;
			text-align: center;
			font-size: 24px;
			color: #9a9b9c;
		}
		.form_left {
			width: 210px;
			float: left;
			height: 30px;
			line-height: 30px;
			color: #333333;
		}
	
		.che {
			float: left;
			color: #666;
			line-height: 21px;
	
			input {
				height: 16px;
				width: 16px;
				margin-bottom: 0;
			}
	
			margin-right: 50px;
		}
	
		.form_right {
			float: left;
			color: #666;
			.beizhu{
				width: 400px;
			}
			input {
				color: #666;
				height: 30px;
				border: 1px solid #8F8F8F;
				width: 400px;
			}
	
			.form_select {
				width: 110px;
				margin-left: 10px;
			}
			.textarea{
				border: 1px solid #D9D9D9;
			}
			select {
				color: #666;
				box-sizing: content-box;
				height: 34px;
				border: 1px solid #D9D9D9;
				width: 286px;
			}
			textarea{
				min-width: 400px;
				max-width: 400px;
				min-height: 120px;
				max-height: 120px;
			}
		}
	}
	
	.order_to {
		margin-top: 30px;
		color: #fff;
		height: 40px;
		background: #005599;
		display: flex;
		align-items: center;
	
		span:nth-child(2) {
			flex: 3;
			text-align: center;
		}
	
		span:not(:nth-child(2)) {
			flex: 1;
			text-align: center;
		}
	}
	.chopping_box {
		color: #333;
		.chopping_zi {
			display: flex;
			align-items: center;
			padding: 30px 0;
			height: 100px;
			border-bottom: 1px solid #D9D9D9;
			.chopping_li {}
			&>div {
				flex: 1;
				text-align: center;
			}
			.chopping_goods {
				flex: 3;
				text-align: left;
					.asdmoi {
						height: 75px;
						margin-left: 20px;
						& :nth-child(1){
							overflow:hidden;
							text-overflow:ellipsis;
							display:-webkit-box;
							-webkit-box-orient:vertical;
							-webkit-line-clamp:2;
							width: 	200px;
						}
						.lan{
							margin-top: 30px;
						}
					}
				img {
					cursor: pointer;
					width: 100px;
					height: 75px;
				}
			}
		}
	}
	.schedule_box {
		.schedule_one {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_1.png) no-repeat 100% 100%;
			color: #fff;
		}
		.schedule_two {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_2_1.jpg) no-repeat 100% 100%;
			background-size: 100% 100%;
			color: #fff;
		}
		.schedule_three {
			background: url(https://tongrenhuaxue.oss-cn-shanghai.aliyuncs.com/default/plan_3.png) no-repeat 100% 100%;
			color: #333;
		}
	}
	.site_zi{
		margin-bottom: 40px;
		border-top: 1px solid #F2F2F2;
		padding-left: 40px;
		.site_title{
			font-size: 24px;
			color: #333;
			.lan{
				color: var(--themeColor);
				margin-left: 60px;
			}
		}
		.site_form{
			margin: 20px 0;
			.form_left{
				width: 100px;
				float: left;
				height: 30px;
				line-height: 30px;
				color: #333333;
			}
			.form_right{
				float: left;
				color: #666;
				input{
					color: #666;
					height: 30px;
					border: 1px solid #D9D9D9;
					width: 280px;
				}
				.form_select{
					width: 110px;
					margin-left: 10px;
				}
				select{
					color: #666;
					box-sizing: content-box;
					height: 34px;
					border: 1px solid #D9D9D9;
					width: 286px;
				}
			}
		}
	}
</style>
